import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  Box,
  Chip,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import { ArrowDownWideNarrow } from 'lucide-react';
import { ChatLogBooking } from '../../types/chat_booking';
import { format } from 'date-fns';

interface Props {
  chatLogs: ChatLogBooking[];
  onSelect: (log: ChatLogBooking) => void;
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (pageSize: number) => void;
  isLoading?: boolean;
}

export default function ChatBookingLogsTable({
  chatLogs,
  onSelect,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  isLoading = false,
}: Props) {
  const theme = useTheme();
  const handleChangePage = (_: unknown, newPage: number) => {
    onPageChange(newPage + 1);
  };

  const handleChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPageSize = +e.target.value;
    onRowsPerPageChange(newPageSize);
    // onPageChange(1);
  };
  console.log('chatLogs', chatLogs);
  console.log('pagination', pagination);

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ px: 3, py: 1, color: theme.palette.text.secondary }}>UID</TableCell>
              <TableCell sx={{ px: 3, py: 1, color: theme.palette.text.secondary }}>Type</TableCell>
              <TableCell sx={{ px: 3, py: 1, color: theme.palette.text.secondary }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>Date</Box>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : chatLogs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : (
              chatLogs.map(log => (
                <TableRow
                  key={log.uuid}
                  hover
                  onClick={() => onSelect(log)}
                  sx={{
                    cursor: 'pointer',
                    backgroundColor: log.isViewed ? 'inherit' : `${theme.palette.primary.main}12`,
                  }}
                >
                  <TableCell
                    sx={{
                      px: 3,
                      fontSize: 15,
                      fontWeight: log.isViewed ? 400 : 500,
                    }}
                  >
                    {log.uuid}
                  </TableCell>

                  <TableCell sx={{ px: 3, fontWeight: 400 }}>
                    <Chip
                      label={log.chatType === 'booking' ? 'Booking' : 'Enquiry'}
                      size="small"
                      sx={{
                        backgroundColor:
                          log.chatType === 'booking'
                            ? `${theme.palette.primary.main}10`
                            : `${theme.palette.secondary.main}10`,
                        color:
                          log.chatType === 'booking'
                            ? theme.palette.primary.main
                            : theme.palette.secondary.main,
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ px: 3, fontWeight: 400 }}>
                    {format(new Date(log.updatedAt), 'MMM d, yyyy, h:mm a')}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.pageSize}
        page={pagination.page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
